module.exports = __webpack_public_path__ + "static/media/07_1.942c8ad0.png";